import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import React from "react";
import { Message } from "./index";
const StaticMessage = React.forwardRef((props, ref) => {
    const { message, type, header, onClose, ...rest } = props;
    return (_jsx("div", { ref: ref, children: _jsx(Message, { children: message, type: type, showIcon: true, onClose: onClose, hidePrefix: true, closable: true, bordered: true, header: header && "Message", ...rest }) }));
});
export default StaticMessage;
